import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, Button, Row, Col, Typography, Tag } from "antd";
import { UserOutlined } from "@ant-design/icons";
import Utilities from "../../dependencies/custom/react-utilities";
import useDrawer from "../../hooks/drawer";
import useAdd from "../../hooks/add";
import useTable from "../../hooks/table";
import Settings from "../../dependencies/custom/settings";
import SurePayPaymentModal from "../../components/finance/payments/SurePayPaymentModal";
const { Title, Text } = Typography;

export default function MyTransport() {
  // const applications = JSON.parse(localStorage.getItem("admissions") || "[]");
  const navigate = useNavigate();
  const drawer = useDrawer();
  const add = useAdd("tables_metadata", "table_name");
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(false);
  const [paymentModalOpen, setPaymentModalOpen] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState(null);
  // const table = useTable();
  const table = useTable(
    {
      pagination: {
        current: 1,
        pageSize: 20,
        hideOnSinglePage: true,
      },
    },
    undefined,
    undefined,
    undefined,
    undefined,
    "id",
    {},
    {},
  );
  const show = applications?.some(
    (v) => v?.status?.toLowerCase() === "admitted",
  );

  // This page should hydrate once on mount; rerunning this effect caused duplicate fetches.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    table.setColumns([
      {
        title: "Name",
        dataIndex: "studentName",
        ...table?.getColumnSearchProps("studentName"),
      },
      {
        title: "Route",
        dataIndex: "routeName",
      },
      {
        title: "Type",
        dataIndex: "transportTypeName",
      },
      {
        title: "Amount",
        dataIndex: "tariff",
        render(v, record) {
          return (
            <label className={"text-successx fw-bold"}>
              UGX {Utilities.formatAccounting(v)}
            </label>
          );
        },
      },
      {
        title: "Status",
        dataIndex: "status",
        render(v, record) {
          return v === "Active" ? (
            <Tag color="green">{v}</Tag>
          ) : (
            <Tag color="blue">{v}</Tag>
          );
        },
      },
      {
        title: "Date",
        dataIndex: "dateBooked",
      },
      {
        title: "Pay",
        render(v, record) {
          return record?.status !== "Active" ? (
            <Button
              onClick={() => pay(record)}
              type="primary"
              icon={<i className="fas fa-coins" />}
            >
              Pay
            </Button>
          ) : (
            <Tag color="green">Paid</Tag>
          );
        },
      },
    ]);
    bootstrap();
    bootstrapApplications();
  }, []);

  async function bootstrap() {
    table.setLoading(true);
    try {
      const res = await Utilities.fetchWithAuth(
        "GET",
        `${Settings?.urls?.transport?.book}/me`,
        undefined,
        navigate,
      );
      if (res.ok) {
        table.setData(res.data);
        // for (let student of applications) {
        //     const studentID1 = student?.student?.id;
        //     const spcCode = student?.student?.spcCode;
        //     for (let booking of res?.data) {
        //         const studentID2 = booking?.studentID;
        //         if (studentID1 == studentID2) {
        //             arr.push({ ...booking, spc: spcCode });
        //         }
        //     }
        // }
        // let final = [];
        // for (let entry of arr) {
        //     const res1 = await Utilities.fetchWithAuth('GET', `${Settings?.urls?.finance?.student_transport_fees}/${entry?.spc}`, undefined, navigate);
        //     if (res1?.ok) {
        //         final.push({ ...entry, showButton: false });
        //     } else {
        //         final.push({ ...entry, showButton: true });
        //     }
        // }
        // table.setData(final);
      }
    } finally {
      table.setLoading(false);
    }
  }

  async function bootstrapApplications() {
    const res = await Utilities.fetchWithAuth(
      "GET",
      Settings.urls.enrollment?.related_applications,
      undefined,
      navigate,
    );
    if (res?.ok) {
      setApplications(res?.data || []);
    } else {
      // Utilities.showNotification(undefined, res?.msg);
    }
  }

  function showTransportDrawer(child) {
    add.setRecord({ studentID: child?.student?.id });
    add.setTblName("PARENT_ROUTES");
    add.setHttpMethod("GET");
    drawer.setPlacement("right");
    drawer.setTitle(
      `Transport for ${child?.student?.firstName} ${child?.student?.lastName}`,
    );
    drawer.setOpen(true);
  }

  function pay(recordOrTpc, tariff) {
    const record =
      typeof recordOrTpc === "object"
        ? recordOrTpc
        : { tpcCode: recordOrTpc, tariff };

    setSelectedPayment({
      paymentCode: record?.tpcCode,
      codeType: "TPC",
      amount: parseFloat(record?.tariff || 0),
      description: `Transport Payment - ${record?.routeName || record?.tpcCode}`,
      studentName: record?.studentName,
      feeLabel: record?.routeName
        ? `Transport - ${record.routeName}`
        : "Transport Fee",
    });
    setPaymentModalOpen(true);
  }

  async function book() {
    const a = add.validateShowErrorMessage();
    if (!a?.isValid) return;
    let d = add.record;
    add.setLoading(true);
    setLoading(true);
    const res = await Utilities.fetchWithAuth(
      "POST",
      Settings.urls.transport.book,
      d,
      navigate,
    );
    if (res?.ok) {
      drawer.setOpen(false);
      add.reset();
      await bootstrap();
      const tpcCode = res?.data?.tpcCode;
      const tariff = res?.data?.tariff;
      pay({ ...res?.data, tpcCode, tariff });
    } else {
      Utilities.showNotification(undefined, res?.msg);
    }
    setLoading(false);
    add.setLoading(false);
  }

  return (
    <div className="p-6">
      <div className="mb-3">
        <Title level={3}>My Transport</Title>
        <Text type="secondary">
          {show
            ? "Select child and choose a transport"
            : "No child has been admitted for transport booking"}
        </Text>
      </div>

      <Row gutter={[16, 16]} className="mt-6">
        <Col xs={24} sm={24} md={12} lg={12}>
          <Row gutter={[16, 16]}>
            {applications?.map(
              (app) =>
                app?.status?.toLowerCase() === "admitted" && (
                  <Col key={app?.admissionID} xs={24} sm={24} md={12} lg={12}>
                    <Card
                      hoverable
                      className="rounded-2xl shadow"
                      actions={[
                        <Button
                          onClick={() => showTransportDrawer(app)}
                          icon={<i className="fas fa-plus" />}
                          type="primary"
                        >
                          Book
                        </Button>,
                      ]}
                    >
                      <div className="flex items-center gap-3 mb-2">
                        <UserOutlined style={{ fontSize: 28 }} />
                        <Title level={5} className="mb-0">
                          {app?.student?.firstName} {app?.student?.lastName}
                        </Title>
                      </div>
                      <Tag color="blue" className="mt-2">
                        {app?.student?.className}
                      </Tag>
                    </Card>
                  </Col>
                ),
            )}
          </Row>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12}>
          {show && (
            <Card
              title={"Transport Booking History"}
              hoverable
              className="rounded-2xl shadow criclebox tablespace table-responsive"
            >
              {table.table}
            </Card>
          )}
        </Col>
      </Row>
      {drawer.drawerJSX(
        1400,
        <>
          {add.form}
          <div>
            <Button
              loading={loading}
              onClick={book}
              type="primary"
              icon={<i className="fas fa-coins" />}
            >
              Book
            </Button>
          </div>
        </>,
      )}
      <SurePayPaymentModal
        open={paymentModalOpen}
        onClose={() => {
          setPaymentModalOpen(false);
          setSelectedPayment(null);
        }}
        onSuccess={async () => {
          setPaymentModalOpen(false);
          setSelectedPayment(null);
          await bootstrap();
        }}
        paymentCode={selectedPayment?.paymentCode}
        codeType={selectedPayment?.codeType}
        amount={selectedPayment?.amount}
        description={selectedPayment?.description}
        studentName={selectedPayment?.studentName}
        feeLabel={selectedPayment?.feeLabel}
        title="Pay Transport Fee"
      />
    </div>
  );
}
